import { render, staticRenderFns } from "./GalleryWithTextAndImageSlide.vue?vue&type=template&id=e541e692&scoped=true&"
import script from "./GalleryWithTextAndImageSlide.vue?vue&type=script&lang=ts&"
export * from "./GalleryWithTextAndImageSlide.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryWithTextAndImageSlide.vue?vue&type=style&index=0&id=e541e692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e541e692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e541e692')) {
      api.createRecord('e541e692', component.options)
    } else {
      api.reload('e541e692', component.options)
    }
    module.hot.accept("./GalleryWithTextAndImageSlide.vue?vue&type=template&id=e541e692&scoped=true&", function () {
      api.rerender('e541e692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/GalleryWithTextAndImage/GalleryWithTextAndImageSlide.vue"
export default component.exports